// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-container {
  padding: 0;
}
.swiper-container .onboarding-animation {
  margin: 0 auto;
  border-radius: 10px;
  width: 90%;
  height: 320px;
  max-width: 450px;
  overflow: hidden;
}
.swiper-container .slide1-animation {
  width: 100%;
  height: 50%;
  max-width: unset;
  border-radius: 0;
  box-shadow: none;
}
.swiper-container swiper-slide {
  height: 100%;
}
.swiper-container .slide1-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.swiper-container .slide1-container .slide1-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
}
.swiper-container .slide1-container .slide1-content .slide1-content-text {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  gap: 30px;
  padding: 0 30px;
}
.swiper-container .slide1-container .slide1-content .slide1-content-text h2 {
  font-size: 24px;
  font-weight: 800;
}
.swiper-container .slide1-container .slide1-content .slide1-content-text ion-text {
  font-size: 14px;
  font-weight: 400;
}
.swiper-container .slide1-container .slide1-content .slide1-content-text ion-button {
  width: 100px;
  margin-top: 50px;
}
.swiper-container .slide1-container .slide1-content .slide1-content-text .skip-onboarding-link {
  background: transparent;
  border: none;
  color: white;
  text-decoration: underline;
  font-size: 12px;
  font-weight: 500;
  padding: 0;
  margin-top: -18px;
}
.swiper-container .slide1-container .slide1-image-container {
  width: 100%;
  height: 100%;
}
.swiper-container .slide1-container .slide1-image-container::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 50%;
  pointer-events: none;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 40%, white 100%);
}
.swiper-container .slide1-container .slide1-image-container img {
  width: 100%;
  height: 50%;
  object-fit: cover;
}
.swiper-container .other-slides-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  padding: 15px 0;
}
.swiper-container .other-slides-container img {
  margin: 0 auto;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  width: 90%;
  height: 320px;
  border-radius: 10px;
  max-width: 450px;
}
.swiper-container .other-slides-container .other-slides-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 20px;
}
.swiper-container .other-slides-container .other-slides-content h2 {
  font-size: 20px;
  font-weight: 700;
}
.swiper-container .other-slides-container .other-slides-content ion-text {
  font-size: 14px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/onboarding/onboarding.component.scss"],"names":[],"mappings":"AAKA;EACE,UAAA;AAJF;AAKE;EACE,cAAA;EAEA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AALJ;AAQE;EACE,YAAA;AANJ;AAQE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AANJ;AAOI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;AALN;AAMM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;AAJR;AAKQ;EACE,eAAA;EACA,gBAAA;AAHV;AAKQ;EACE,eAAA;EACA,gBAAA;AAHV;AAKQ;EACE,YAAA;EACA,gBAAA;AAHV;AAKQ;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;AAHV;AAOI;EACE,WAAA;EACA,YAAA;AALN;AAMM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,yGAAA;AAJR;AAWM;EACE,WAAA;EACA,WAAA;EACA,iBAAA;AATR;AAaE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;AAXJ;AAYI;EACE,cAAA;EACA,yCAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAVN;AAaI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAXN;AAYM;EACE,eAAA;EACA,gBAAA;AAVR;AAYM;EACE,eAAA;EACA,gBAAA;AAVR","sourcesContent":["\n\n\n\n\n.swiper-container {\n  padding: 0;\n  .onboarding-animation {\n    margin: 0 auto;\n    // box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n    border-radius: 10px;\n    width: 90%;\n    height: 320px;\n    max-width: 450px;\n    overflow: hidden;\n  }\n\n  .slide1-animation {\n    width: 100%;\n    height: 50%;\n    max-width: unset;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  swiper-slide {\n    height: 100%;\n  }\n  .slide1-container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    .slide1-content {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(0, 0, 0, 0.75);\n      .slide1-content-text {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 60%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        color: white;\n        gap: 30px;\n        padding: 0 30px;\n        h2 {\n          font-size: 24px;\n          font-weight: 800;\n        }\n        ion-text {\n          font-size: 14px;\n          font-weight: 400;\n        }\n        ion-button {\n          width: 100px;\n          margin-top: 50px;\n        }\n        .skip-onboarding-link {\n          background: transparent;\n          border: none;\n          color: white;\n          text-decoration: underline;\n          font-size: 12px;\n          font-weight: 500;\n          padding: 0;\n          margin-top: -18px;\n        }\n      }\n    }\n    .slide1-image-container {\n      width: 100%;\n      height: 100%;\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 50%;\n        pointer-events: none;\n        background: linear-gradient(\n          to bottom,\n          rgba(255, 255, 255, 0) 0%,\n          rgba(255, 255, 255, 0) 40%,\n          white 100%\n        );\n      }\n      img {\n        width: 100%;\n        height: 50%;\n        object-fit: cover;\n      }\n    }\n  }\n  .other-slides-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    flex: 1;\n    padding: 15px 0;\n    img {\n      margin: 0 auto;\n      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n      border-radius: 10px;\n      width: 90%;\n      height: 320px;\n      border-radius: 10px;\n      max-width: 450px;\n\n    }\n    .other-slides-content {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      padding: 0 20px;\n      h2 {\n        font-size: 20px;\n        font-weight: 700;\n      }\n      ion-text {\n        font-size: 14px;\n        font-weight: 400;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
